import { Button } from '@/components/ui/button';
import { useLocation } from 'wouter';
import { cn } from '@/lib/utils'; // Utility function to concatenate class names

interface HeroNavButtonsProps {
  className?: string;
}

export function HeroNavButtons({ className }: HeroNavButtonsProps) {
  const [location, navigate] = useLocation();

  const isAbout = location === '/about';
  const isHome = location === '/home';

  return (
    <div className={cn('mt-6 flex flex-row items-center justify-center w-full', className)}>
      <Button variant={isAbout ? 'default' : 'secondary'} onClick={() => navigate('/about')}>
        О хоумах
      </Button>
      <Button
        variant={isHome ? 'default' : 'secondary'}
        className="ml-2.5"
        onClick={() => navigate('/home')}
      >
        Каталог игр
      </Button>
    </div>
  );
}
